// Your Stripe Payment Link — created in YOUR Stripe dashboard, so every
// payment goes straight to your Stripe account.
// To change it later: Stripe dashboard -> Payment Links -> copy new link -> paste here.
export const STRIPE_PAYMENT_LINK = "https://buy.stripe.com/4gM00j4dG5vM9DCc0lgbm00";
